import {Button, Col, Form, Row, Space} from "antd";
import {PaidSVG, PrintColorWhiteSVG} from "assets";

import React, {useEffect, useRef} from "react";
import "./Detail.scss";

import ListGlass from "./ListGlass/ListGlass";
import BillGlass from "./BillGlass/BillGlass";

import PatientInfo from "./PatientInfo/PatientInfo";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  getDetailBillAPI,
  setDetailBill,
  setGlassRef,
  setPatientRef,
  setStatusBill,
  setStoreId,
  updateStatusBillAPI,
} from "redux/reducer/glassKiot";
import {LOAI_FORM, TT_DON_KINH, tabKeys} from "types/enums";
import {setActiveKey, setIdPhieuKham} from "redux/reducer/common";
import {ModalCustom} from "components/common";
import BillModal from "./BillModal/BillModal";
import {LOAI_DON_KINH} from "types/enums/glass";
import ReturnModal from "./ReturnModal/ReturnModal";

const BillDetails = () => {
  const dispatch = useAppDispatch();

  const idBill = useAppSelector(state => state.glassKiot.idBill);
  const statusBill = useAppSelector(state => state.glassKiot.statusBill);
  const typePrescription = useAppSelector(
    state => state.glassKiot.typePrescription
  );
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  const patientRef = useRef<any>(null);
  const glassRef = useRef<any>(null);
  const listGlassRef = useRef<any>(null);
  const billRef = useRef<any>();
  const returnRef = useRef<any>();

  useEffect(() => {
    dispatch(setDetailBill(null));
    if (idBill != null) {
      dispatch(getDetailBillAPI(idBill));
    } else if (typePrescription != LOAI_DON_KINH.DA_TAO) {
      dispatch(setDetailBill(null));
    }
  }, [idBill, typePrescription]);
  useEffect(() => {
    if (detailBill != null && typePrescription == LOAI_DON_KINH.DA_TAO) {
      dispatch(setStatusBill(detailBill?.glassesSalesDto?.status));
    } else {
      dispatch(setStatusBill(TT_DON_KINH.CHUA_BAN));
    }
    dispatch(setIdPhieuKham(detailBill?.glassesSalesDto?.idPhieuKham));
    dispatch(setStoreId(detailBill?.glassesSalesDto?.storeId));
  }, [detailBill, typePrescription]);
  useEffect(() => {
    dispatch(setPatientRef(patientRef.current));
  }, [patientRef]);
  useEffect(() => {
    dispatch(setGlassRef(glassRef.current));
  }, [glassRef]);
  const changeStatusDetailBill = (status: TT_DON_KINH) => {
    const newDetailBill = {id: idBill, status: status};
    dispatch(updateStatusBillAPI(newDetailBill));
  };

  // useEffect(() => {
  //   if (detailBill == null && typePrescription == LOAI_DON_KINH.TAO_MOI) {
  //     dispatch(setActiveKey(tabKeys.GLASSES.TAB_1));
  //   } else {
  //     dispatch(setActiveKey(tabKeys.GLASSES.TAB_2));
  //   }
  // }, [detailBill, typePrescription]);

  return (
    <div className="bill-details">
      {/* <Form form={form}> */}
      <Space style={{width: "100%"}} className="container" direction="vertical">
        <PatientInfo ref={patientRef}></PatientInfo>

        <Row gutter={[4, 16]} justify={"end"}>
          {/* {statusBill == TT_DON_KINH.CHUA_BAN && (
            <Col>
              <Button
                style={{width: "100%"}}
                type="primary"
                danger
                onClick={() => {
                  changeStatusDetailBill(TT_DON_KINH.HUY);
                }}
              >
                Hủy bỏ
              </Button>
            </Col>
          )} */}

          <Col>
            <Button
              className="btn-sub"
              icon={<PrintColorWhiteSVG />}
              onClick={() => {
                billRef?.current.openModal();
              }}
            >
              In hoá đơn
            </Button>
          </Col>
          <Col>
            {typePrescription == LOAI_DON_KINH.DA_TAO &&
              statusBill == TT_DON_KINH.HOAN_LAI && (
                <Button
                  className="btn-sub"
                  icon={<PrintColorWhiteSVG />}
                  onClick={() => {
                    returnRef?.current.openModal();
                  }}
                >
                  In phiếu hoàn trả
                </Button>
              )}
          </Col>
          <Col>
            {statusBill == TT_DON_KINH.DA_BAN && (
              <Button
                type="primary"
                onClick={() => {
                  listGlassRef?.current?.returnBill();
                }}
              >
                Hoàn trả
              </Button>
            )}
          </Col>
        </Row>
        {/* </Col> */}
      </Space>
      {/* Đơn kính */}
      <BillGlass ref={glassRef} />
      {/* Danh sach kinh trong don */}
      <ListGlass ref={listGlassRef} />
      {/* </Form> */}

      <ModalCustom
        wrapClassName="modal-print-form"
        ref={billRef}
        width={1100}
        centered
      >
        <BillModal />
      </ModalCustom>
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={returnRef}
        width={1100}
        centered
      >
        <ReturnModal />
      </ModalCustom>
    </div>
  );
};

export default BillDetails;
